import { render, staticRenderFns } from "./select-tab.vue?vue&type=template&id=15c35a81&scoped=true"
import script from "./select-tab.vue?vue&type=script&lang=js"
export * from "./select-tab.vue?vue&type=script&lang=js"
import style0 from "./select-tab.vue?vue&type=style&index=0&id=15c35a81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c35a81",
  null
  
)

export default component.exports